import * as PropTypes from 'prop-types';
import * as React from 'react';
import { ThemeProvider } from '../../styled-components';
import { OptionsProvider } from '../OptionsProvider';
import { AppStore } from '../../services';
import { ApiInfo } from '../ApiInfo/';
import { ApiLogo } from '../ApiLogo/ApiLogo';
import { ContentItems } from '../ContentItems/ContentItems';
import { SideMenu } from '../SideMenu/SideMenu';
import { StickyResponsiveSidebar } from '../StickySidebar/StickyResponsiveSidebar';
import { ApiContentWrap, BackgroundStub, RedocWrap } from './styled.elements';
import { SearchBox } from '../SearchBox/SearchBox';
import { StoreProvider } from '../StoreBuilder';
export interface RedocProps {
  store: AppStore;
  hasApiInfo?: boolean | null | undefined;
  hasSideNav?: boolean | null | undefined;
}
export class Redoc extends React.Component<RedocProps> {
  static propTypes = {
    store: PropTypes.instanceOf(AppStore).isRequired,
    hasApiInfo: PropTypes.bool,
    hasSideNav: PropTypes.bool
  };

  componentDidMount() {
    this.props.store.onDidMount();
  }

  componentWillUnmount() {
    this.props.store.dispose();
  }

  render() {
    const {
      store: {
        spec,
        menu,
        options,
        search,
        marker
      }
    } = this.props;
    const store = this.props.store;
    const hasApiInfo = this.props.hasApiInfo;
    const hasSideNav = this.props.hasSideNav;
    return <ThemeProvider theme={options.theme}>
        <StoreProvider value={this.props.store}>
          <OptionsProvider value={options}>
            <RedocWrap className="redoc-wrap">
              <StickyResponsiveSidebar menu={menu} className="menu-content">
                <ApiLogo info={spec.info} />
                {!options.disableSearch && <SearchBox search={search!} marker={marker} getItemById={menu.getItemById} onActivate={menu.activateAndScroll} /> || null}
                {hasSideNav ? <SideMenu menu={menu} /> : ''}
              </StickyResponsiveSidebar>
              <ApiContentWrap className="api-content">
                {hasApiInfo ? <ApiInfo store={store} /> : ''}
                <ContentItems items={(menu.items as any)} />
              </ApiContentWrap>
              <BackgroundStub />
            </RedocWrap>
          </OptionsProvider>
        </StoreProvider>
      </ThemeProvider>;
  }

}